import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./index.css";
import { AuthProvider } from "./auth/AuthContext";
import { UserProvider } from "./auth/UserContext";
import { AppThemeProvider } from "./theme/ThemeModeContext";
import ProtectedRoute from "./components/protect/ProtectedRoute";

import Login from "./pages/login/Login";
import Users from "./pages/users/Users";
import Welcome from "./pages/wellcome/Wellcome";

import VerseSidebarLayout from "./components/verses/VerseSidebarLayout";
import AboutMe from "./pages/aboutme/aboutMe";
import { ClientPage } from "./pages/client/client";
import { Company } from "./pages/company/company";
import FinancialCategories from "./pages/financial/FinancialCategories";
import Downloads from "./pages/downloads/Downloads";
import FinancialEntries from "./pages/financial/FinancialEntries";
import FinancialOverview from "./pages/financial/FinancialOverview";
import { Historic } from "./pages/historic/historic";
import { MovimentPage } from "./pages/moviment/moviment";
import MovimentDetail from "./pages/moviment/MovimentDetail";
import { PendingPage } from "./pages/pending/pending";
import { Product } from "./pages/product/product";
import { TaskPage } from "./pages/task/task";
import Sale from "./pages/sale/sale";
import SaleList from "./pages/sale/sale_list/sale_list";
import { SchedulingPage } from "./pages/scheduling/scheduling";
import { Subscription } from "./pages/subscription/subscription";
import { SubscriptionConfig } from "./pages/subscription/subscription_config";
import { Ticket } from "./pages/ticket/ticket";
import { ToolsPage } from "./pages/tools/tools";
import Utilitarian from "./pages/utilitarian/utilitarianPage";
import WorkOrderDetail from "./pages/workOrder/WorkOrderDetail";
import { WorkOrderPage } from "./pages/workOrder/WorkOrderPage";
import TechnicalReportPage from "./pages/technicalReport/TechnicalReportPage";
import ReportBrandingPage from "./pages/reportBranding/ReportBrandingPage";
import SignaturesPage from "./pages/documents/SignaturesPage";
import ReceiptPage from "./pages/documents/ReceiptPage";
import { purgeLegacyLocalStorageSession } from "./auth/session";

// Sessões antigas viviam em localStorage e sobreviviam ao desligar o PC.
// Limpa antes de montar a árvore, para que os contextos leiam só sessionStorage.
purgeLegacyLocalStorageSession();

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <AuthProvider>
        <UserProvider>
        {/* <ToasterPortal /> */}
        <BrowserRouter>
          {/* <Toaster /> */}
          <Routes>
            {/* Rota pública de login */}
            <Route path="/login" element={<Login />} />
            <Route path="/aboutme" element={<AboutMe />} />

            {/* Todas as rotas abaixo usam o layout com Sidebar + VerseSidebar */}
            <Route path="/" element={<VerseSidebarLayout />}>
              {/* Redireciona “/” para /login ou /welcome conforme autenticação */}
              <Route index element={<Navigate to="/login" replace />} />

              <Route
                path="welcome"
                element={
                  <ProtectedRoute>
                    <Welcome />
                  </ProtectedRoute>
                }
              />

              <Route
                path="utilitarian"
                element={
                  <ProtectedRoute>
                    <Utilitarian />
                  </ProtectedRoute>
                }
              />

              <Route
                path="users"
                element={
                  <ProtectedRoute>
                    <Users />
                  </ProtectedRoute>
                }
              />

              <Route
                path="product"
                element={
                  <ProtectedRoute>
                    <Product />
                  </ProtectedRoute>
                }
              />

              <Route
                path="company"
                element={
                  <ProtectedRoute>
                    <Company />
                  </ProtectedRoute>
                }
              />

              <Route
                path="signatures"
                element={
                  <ProtectedRoute>
                    <SignaturesPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="receipt"
                element={
                  <ProtectedRoute>
                    <ReceiptPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="report-branding"
                element={
                  <ProtectedRoute>
                    <ReportBrandingPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="client"
                element={
                  <ProtectedRoute>
                    <ClientPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="scheduling"
                element={
                  <ProtectedRoute>
                    <SchedulingPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="moviment"
                element={
                  <ProtectedRoute>
                    <MovimentPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="moviment-details/:id"
                element={
                  <ProtectedRoute>
                    <MovimentDetail />
                  </ProtectedRoute>
                }
              />

              <Route
                path="pending"
                element={
                  <ProtectedRoute>
                    <PendingPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="task"
                element={
                  <ProtectedRoute>
                    <TaskPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="tools"
                element={
                  <ProtectedRoute>
                    <ToolsPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="workorder"
                element={
                  <ProtectedRoute>
                    <WorkOrderPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="workorder-details/:id"
                element={
                  <ProtectedRoute>
                    <WorkOrderDetail />
                  </ProtectedRoute>
                }
              />

              <Route
                path="workorder-details/:id/technical-report"
                element={
                  <ProtectedRoute>
                    <TechnicalReportPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="sale"
                element={
                  <ProtectedRoute>
                    <Sale />
                  </ProtectedRoute>
                }
              />

              <Route
                path="sale/list"
                element={
                  <ProtectedRoute>
                    <SaleList />
                  </ProtectedRoute>
                }
              />

              <Route
                path="historic"
                element={
                  <ProtectedRoute>
                    <Historic />
                  </ProtectedRoute>
                }
              />

              <Route
                path="ticket"
                element={
                  <ProtectedRoute>
                    <Ticket />
                  </ProtectedRoute>
                }
              />

              <Route
                path="subscriptions-config"
                element={
                  <ProtectedRoute>
                    <SubscriptionConfig />
                  </ProtectedRoute>
                }
              />

              <Route
                path="subscriptions"
                element={
                  <ProtectedRoute>
                    <Subscription />
                  </ProtectedRoute>
                }
              />

              <Route
                path="financial"
                element={
                  <ProtectedRoute>
                    <FinancialOverview />
                  </ProtectedRoute>
                }
              />

              <Route
                path="financial/entries"
                element={
                  <ProtectedRoute>
                    <FinancialEntries />
                  </ProtectedRoute>
                }
              />

              <Route
                path="financial/categories"
                element={
                  <ProtectedRoute>
                    <FinancialCategories />
                  </ProtectedRoute>
                }
              />

              <Route
                path="downloads"
                element={
                  <ProtectedRoute>
                    <Downloads />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
        </UserProvider>
      </AuthProvider>
    </AppThemeProvider>
  </React.StrictMode>
);
